import { Outlet, useNavigate } from "react-router-dom";

import { Layout, Tabs, TabsProps } from "antd";
import "styles/pages/Dashboard/Dashboard.scss";
import React from "react";
import { Icon } from "@iconify/react";

const { Content } = Layout;

const MembershipLayout = () => {
  const navigate = useNavigate();

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <>
          <Icon icon="gala:settings" /> General
        </>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <Icon icon="solar:settings-linear" /> Configuración
        </>
      ),
    },
  ];

  const handleTabClick = (key: string) => {
    if (key == "1") {
      navigate("/memberships/general");
    } else if (key == "2") {
      navigate("/memberships/config");
    }
  };

  return (
    <Layout id={"membership"}>
      <Layout>
        <Tabs items={items} onTabClick={handleTabClick} />
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MembershipLayout;
